/**
 * @desc 查询矿化剂需求月计划
 */

import * as defs from '../../baseClass';
import { defHttp } from 'hailuo-http';
export interface Params {}

export function request(
  data: defs.IdRequest,
): Promise<defs.StandardReturn<defs.PlanMonthMineralizerResponse>> {
  return defHttp.post({
    url: '/wap/plan/month/queryPlanMineralizer',
    data,
  });
}

export function mock(
  data: defs.IdRequest,
): Promise<defs.StandardReturn<defs.PlanMonthMineralizerResponse>> {
  return defHttp.post({
    url: '/mock/wap/plan/month/queryPlanMineralizer',
    data,
  });
}
